import { FunctionComponent } from 'react';
import Script from 'next/script';

interface Props {
  containerId: string;
}

export const GoogleAntiFlicker: FunctionComponent<Props> = ({ containerId }) => {
  if (containerId === null) containerId = '';

  return (
    <Script
      id="google-anti-flicker"
      strategy="afterInteractive"
      async
      dangerouslySetInnerHTML={{
        __html: `
        (function(a,s,y,n,c,h,i,d,e){s.className+=' '+y;h.start=1*new Date;
        h.end=i=function(){s.className=s.className.replace(RegExp(' ?'+y),'')};
        (a[n]=a[n]||[]).hide=h;setTimeout(function(){i();h.end=null},c);h.timeout=c;
        })(window,document.documentElement,'async-hide','dataLayer',4000,
        {'${containerId}':true});
      `,
      }}
    />
  );
};
